import { render, staticRenderFns } from "./PowerFewShotHead.vue?vue&type=template&id=33e9a12a&scoped=true"
import script from "./PowerFewShotHead.vue?vue&type=script&lang=js"
export * from "./PowerFewShotHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e9a12a",
  null
  
)

export default component.exports